import React from 'react';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import request from 'arcdynamic-request';
class TerritoryTeam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: Array.isArray(this.props.items) ? this.props.items : []
        };
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.items !== this.props.items) {
            this.setState({
                items: Array.isArray(this.props.items) ? this.props.items : []
            });
        }
    }
   
     render() {
        const {
            theme,
            value,
            valueKey,
            percentKey,
            label,
            percentLabel,
            disabled,
            data,
            isFilter,
            handleParentChange,
            handleInputParentChange,
            viewMode,
            deleted,
            isFromProperty,
            hasAgentPercent,
            ...rest
        } = this.props;
        const { items } = this.state;
      
        // Ensure items is always an array
        const itemsArray = Array.isArray(items) ? items : [];
        let itemsSorted = itemsArray.filter((obj,index) =>{ 
            return index === itemsArray.findIndex(o=> obj.AGENT_NAME === o.AGENT_NAME)
        });

        itemsSorted.sort((a,b) => {
            if(a.AGENT_NAME < b.AGENT_NAME) return -1;
            if(a.AGENT_NAME > b.AGENT_NAME) return 1;
            return 0;
        })
        const territoryRecords = [
            {
                "TERRITORY_MARKET": "West Texas,Houston,Central Texas,Valley",
                "PRODUCT_TYPE": "",
                "TERRITORY": "1",
                "AGENT_ID": "Territory1",
                "DELETED": null,
                "AGENT_NAME": "Territory 1",
            },
            {
                "TERRITORY_MARKET": "DFW,Houston",
                "PRODUCT_TYPE": "Multi-Family,Office,STNL Retail,Industrial",
                "TERRITORY": "2,3",
                "AGENT_ID": "Territory2",
                "DELETED": null,
                "AGENT_NAME": "Territory 2",
            },
            {
                "TERRITORY_MARKET": "DFW,Houston",
                "PRODUCT_TYPE": "Office,Industrial,STNL Retail",
                "TERRITORY": "3",
                "AGENT_ID": "Territory3",
                "DELETED": null,
                "AGENT_NAME": "Territory 3",
            },
            {
                "TERRITORY_MARKET": "Houston",
                "PRODUCT_TYPE": "Office,Industrial,MT Retail",
                "TERRITORY": "4",
                "AGENT_ID": "Territory4",
                "DELETED": null,
                "AGENT_NAME": "Territory 4",
            }
        ]
        itemsSorted = [...itemsSorted, ...territoryRecords]

        return (
            <Dropdown theme={theme}
                      optionsType='territory'
                      optionKey='AGENT_ID'
                      optionLabelKey='AGENT_NAME'
                      options={itemsSorted}
                      value={value}
                      valueKey={valueKey}
                      percentKey={percentKey}
                      label={label}
                      percentLabel={percentLabel}
                      disabled={!itemsArray || itemsArray.length === 0 || disabled}
                      data={data}
                      isFilter={isFilter}
                      groupBy={true}
                      handleParentChange={handleParentChange}
                      handleInputParentChange={handleInputParentChange}
                      viewMode={viewMode}
                      deleted={deleted}
                      isFromProperty={isFromProperty}
                      hasAgentPercent={hasAgentPercent}
                      {...rest}
            />
        )
    }
}

TerritoryTeam.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    groupBy: PropTypes.bool,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    handleInputParentChange: PropTypes.func,
    items:PropTypes.array
};

export default TerritoryTeam;
